// IMPORTANT: this is a plugin which requires jQuery for initialisation and data manipulation

import { Component, OnInit, ElementRef, Inject, AfterViewInit, HostListener } from '@angular/core';
import {FormBuilder , Validators, FormsModule, ReactiveFormsModule }  from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { UserService } from '../../services/user.service';
import { User } from '../../models/user';
import { LocationService } from '../../services/location.service';
import { Methods } from '../../shared/methods';
import { DinamicData, Cell } from '../../models/dinamic-data';
import { ConfigService } from '../../services/config.service';
import swal from 'sweetalert2';
import { GuiGuard } from '../../shared/guard/base-gui-guard';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDateFormats, NativeDateAdapter } from '@angular/material/core';


declare interface DataTable {
  headerRow: string[];
  footerRow: string[];
  dataRows: string[][];
}

declare const $: any;

@Component({
  selector: 'app-listpersonal-cmp',
  templateUrl: 'listpersonal.component.html',
  styleUrls: ['./listpersonal.component.css'],
  providers: [UserService]
})

export class ListpersonalComponent implements OnInit, AfterViewInit {
  public mtds: Methods = new Methods();
  public activos = 1;
  name: string;
  animal: string;
  public dataTable: DataTable;
  public privilegio;
  sexos = [
  { value: '0', viewValue: 'Female' },
    { value: '1', viewValue: 'Male' },
    { value: '2', viewValue: 'Other' }
    
  ];

  frequencies = [
    { value: 'DAILY', viewValue: 'Daily' },
    { value: 'WEEKLY', viewValue: 'Weekly' },
    { value: 'MONTHLY', viewValue: 'Monthly' },
    { value: 'NEVER', viewValue: 'Never' },
  ];

  public pacientes: Array<User>;
  public identity;
  public token;
  public pages;
  public pagePrev;
  public pageNext;
  public loading;
  public filter = 0;
  public order = 0;
  public searchString;
  public user;
  public status_user;
  public pageLimit = '10';
  public page = 1;
  public totalItems = 0;
  public totalPaginas = 1;
  public companyLinked = null;
  //
  public optionsButtonSelect;
  public optionSelectMenuTrigger;
  public filtros = [];
  //
  public config: Array<any> = [];
  public staffData: DinamicData = new DinamicData(
    ['Id', 'Name', 'Title', 'Department', 'City', 'Status', 'Actions']
  )


  constructor(
    private titleService: Title, public dialog: MatDialog,
    private _route: ActivatedRoute,
    private _router: Router,
    private _config: ConfigService,
    private _userService: UserService,
    public guard: GuiGuard
  ) {
    this.titleService.setTitle('Representatives');
    this.privilegio = JSON.parse(localStorage.getItem("privilegio"));
    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();

   

    this._userService.getUser(this.token, this.identity.sub ).subscribe(
        response => {
          console.log(response);
          if(response.status == 'success'){
           
             this.companyLinked = response.data.companyLinked;
              console.log(this.companyLinked);
            
          }
        },
        error => {
          console.log(<any>error);
        }
      );

    console.log(this.guard.permissions('addrepresentative'));
  }

  pipeRep(rep) {
    switch (rep) {
      case 'SALESREP':
        return 'SALES REP';
      case 'TECHREP':
        return 'TECH REP';
      case 'ADMINISTRATOR':
        return 'ADMINISTRATOR';
      case 'CLERICALREP':
        return 'CLERICAL REP';
      case 'SHIPPINGREP':
        return 'SHIPPING REP';
      case 'PURCHASINGREP':
        return 'PURCHASING REP';
      case 'RECEIVINGDEPARTMENT':
        return 'RECEIVING DEPARTMENT';
      case 'MANIFESTDEPARTMENT':
        return 'MANIFEST DEPARTMENT';
      case 'MANAGER':
        return 'MANAGER';
      case 'DRIVER':
        return 'DRIVER';
      case 'TECHREP':
        return 'TECH REP';
      case 'WAREHOUSE SUPERVISOR':
        return 'WAREHOUSE SUPERVISOR';
      default:
        return rep;
    }
  }

  showSwal(type) {
    if (type === 'success-message') {
      swal.fire({
    
        title: 'Rep has been added!',
        text: '',
        buttonsStyling: false,
       

 customClass:{
    confirmButton: 'btn btn-success'
            },

      });

    } else if (type === 'warning-message-and-confirmation') {
      swal.fire({
        title: 'Are you sure?',
        text: 'You will not be able to revert this!',
    
        showCancelButton: true,
        
        customClass:{
    confirmButton: 'btn btn-success',
    cancelButton: 'btn btn-danger',
            },
        confirmButtonText: 'Yes, delete it!',
        buttonsStyling: false
      }).then(function () {
        swal.fire({
          title: 'Deleted!',
          text: 'Your file has been deleted.',
         
         customClass:{
    confirmButton: 'btn btn-success'
            },
          buttonsStyling: false
        });
      });
    } else if (type === 'warning-message-and-cancel') {
      swal.fire({
        title: 'Are you sure?',
        text: 'You will not be able to recover this imaginary file!',
    
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it',
  
        customClass:{
    confirmButton: 'btn btn-success',
    cancelButton: 'btn btn-danger',
            },
        buttonsStyling: false
      }).then(function () {
        swal.fire({
          title: 'Deleted!',
          text: 'Your imaginary file has been deleted.',
    
       customClass:{
    confirmButton: 'btn btn-success'
            },
          buttonsStyling: false
        });
      }, function (dismiss) {
        // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
        if (dismiss === 'cancel') {
          swal.fire({
            title: 'Cancelled',
            text: 'Your imaginary file is safe :)',
     
            customClass:{
    confirmButton: 'btn btn-info'
            },
            buttonsStyling: false
          });
        }
      });
    } else if (type === 'custom-html') {
      swal.fire({
        title: 'HTML example',
        buttonsStyling: false,
 
        customClass:{
    confirmButton: 'btn btn-success'
            },
        html:
          'You can use <b>bold text</b>, ' +
          '<a href="http://github.com">links</a> ' +
          'and other HTML tags'
      });

    } else if (type === 'auto-close') {
      swal.fire({
        title: 'Auto close alert!',
        text: 'I will close in 2 seconds.',
        timer: 2000,
        showConfirmButton: false
      }).then(
        function () { },
        // handling the promise rejection
        function (dismiss) {
          if (dismiss === 'timer') {
            console.log('I was closed by the timer')
          }
        });
    } else if (type === 'input-field') {
      swal.fire({
        title: 'Input something',
        html: '<div class="form-group">' +
          '<input id="input-field" type="text" class="form-control" />' +
          '</div>',
        showCancelButton: true,
     

        customClass:{
    confirmButton: 'btn btn-success',
    cancelButton: 'btn btn-danger',
            },

        buttonsStyling: false
      }).then(function (result) {
        swal.fire({
        
          html: 'You entered: <strong>' +
            $('#input-field').val() +
            '</strong>',
          
 customClass:{
    confirmButton: 'btn btn-success'
            },
          buttonsStyling: false

        });
      });
    }
  }



  openNuevoPaciente(): void {
    this.user = new User(1, '', '', '', '', '', this.companyLinked.name, '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 0, '', 1, 1, 1, '', 0, this.companyLinked, '0', '', 0, 0, 0, 0, 0, 0, 0, {id: null}, '', '', '', '');
    console.log(this.user);
    let dialogRef = this.dialog.open(NuevoPersonal, {
      width: '80%',
      data: { user: this.user, sexos: this.sexos }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      if(result){
         this._userService.create(this.token, result).subscribe(
        response => {
          console.log(response);
          this.status_user = response.status;

          if (this.status_user != 'success') {
            this.status_user = 'error';
            if (response.code === 400) {
              alert('It was not possible to add the user because: ' + response.msg);
            } else {
              alert('Error! Something went wrong, it was not possible to add the user');
            }
          } else {
            this.showSwal('success-message');
            //this.animal = result;
            this.getAllPacientes();
          }
        },
        error => {
          console.log(<any>error);
        }
      );

      }
     

    });
  }
  menuTriggerToShow(newValue: string) {
    if (newValue === "Active") { this.activos = 0; } else { this.activos = 1 }
    this.cambiarActivos()
  }
  ngOnInit() {
    this.cargando = true;
        //
        this.optionsButtonSelect= [
          { value: 'Active', label: 'Active'},
          { value: 'Inactive', label: 'Inactive'},
        ];
        this.optionSelectMenuTrigger='Active';
        //
    if (this.identity == null && this.identity.sub) {
      localStorage.clear();
      this._router.navigate(['/pages/lock']);
    } else {
      this._config.getConfig('staffList').subscribe(
        r => {
          if (r.data) {
            this.config = JSON.parse(r.data.data);
          } else {
            this.config = this.mtds.colopt(
              this.staffData.headers, [false]
            );
          }
          this.getAllPacientes();
        }, error => {
          this.mtds.notifyError(error.statusText, error.status);
          this.cargando = false;
        }
      );
      
    }

  }

  updateConfig(e) {
    this.config = e;
    console.log(this.config);
    this._config.setConfig('staffList', this.config).subscribe(
      r => {
        console.log(r);
      }
    );
  }

  cambiarActivos() {
    if (this.activos === 1) { this.activos = 0; } else { this.activos = 1 }

    this.getAllPacientes();
  }

  deleteFolderfirst(folder) {

    swal.fire({
      title: '',
      text: 'Do you want to make this representative ' + (this.activos === 1 ? 'inactive' : 'active'),
      icon: "info",
      showCancelButton: true,
      buttonsStyling: false,

      customClass:{
    confirmButton: 'gts-btn-primary',
    cancelButton: 'gts-btn-primary-outline',
            },
      confirmButtonColor: '#9c27b0',
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
    }).then(function (result) {
      if (result.value) {
        this._userService.deleteUser(this.token, folder).subscribe(
          response => {
            console.log(response);
            if (response.status === 'success') {

              this.getAllPacientes();
              this.mtds.notifySuccess(
                this.activos === 1 ? 'Employee status has been changed to inactive' : 'Employee status has been changed to active'
                );
            } else {
              this.mtds.notifyError(response.msg, response.code);
            }
          }, error => {
            this.mtds.notifyError(error.statusText, error.status);
          }
        );
      }
    }.bind(this));
  }

  public cargando = false;

  actions(e) {
    // ['/pages/user', item.id]
    // deleteFolderfirst(item.id)
    switch (e.action) {
      case 'Detail':
        this._router.navigate(["/pages/user", e.id]);
        break;
      case 'Active':
        this.deleteFolderfirst(e.id);
        break;
      case 'Inactive':
        this.deleteFolderfirst(e.id);
        break;
      default:
        break;
    }
    console.log(e);
  }
//

getData(e = null){
  console.log(e)
  this.cargando = true;
  this._route.params.forEach((params: Params) => {
    /* let page = + params['page'];

    if (!page) {
      page = 1;
    } */
    this.staffData.rows = [];
    this.loading = 'show';
    this._userService.getAllUsersType(this.token, "workers", e !== null ? (this.page = e.page) : (this.page = 1), 'ALL', this.activos,1,this.filtros,e !== null ? (this.pageLimit = e.perPage) : (this.pageLimit = '10') ).subscribe(
      response => {
        this.pacientes = response.data;
        this.mtds.initTable('#datatables');
        console.log(response);
        if (response.status == 'success') {
          this.page = Number(response.page_actual);
          this.totalItems = Number(response.total_items_count);
          this.totalPaginas = Number(response.total_pages);
          for (let element of response.data) {
            this.staffData.rows.push(
              [
                new Cell(element.id),
                new Cell(element.name + ' ' + element.surname),
                new Cell(element.ocupation),
                new Cell(this.mtds.capitalize(this.pipeRep(element.role))),
                new Cell(element.city),
                new Cell(element.activo == 1 ? 'Active' : 'Inactive', {type: 'action-button', value: {id: element.id}, icon: 'power_settings_new', class: element.activo == 1 ? 'btn-success' : 'gts-btn-secondary ' ,typeaction: element.activo  == 1 ? 'Active' : 'Inactive'}),
                new Cell(
                  [
                    { icon: 'remove_red_eye', action: 'Detail', color: 'info' }
                  ], {type: 'actions'}
                )
              ]
            );
          }

          this.loading = 'hide';

        } else {
          localStorage.clear();
          this._router.navigate(['/pages/lock']);

        }
        this.cargando = false;
      },
      error => {
        console.log(<any>error);
        this.cargando = false;
      }
    );
  });
}
//
  getAllPacientes() {
    this.filtros = [
      null,
      {
        key: "name",
        title: "Name",
        value: "",
        type: "contains",
        key_type: "name_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "ocupation",
        title: "Title",
        value: "",
        type: "contains",
        key_type: "ocupation_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "role",
        title: "Department",
        value: "",
        type: "contains",
        key_type: "role_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "city",
        title: "City",
        value: "",
        type: "contains",
        key_type: "city_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      null,
    ];
    this.cargando = true;
    this._route.params.forEach((params: Params) => {
      let page = + params['page'];

      if (!page) {
        page = 1;
      }
      this.staffData.rows = [];
      this.loading = 'show';

      this._userService.getAllUsersType(this.token, "workers", page, 'ALL', this.activos,1,this.filtros,this.pageLimit).subscribe(
        response => {
          this.pacientes = response.data;
          this.mtds.initTable('#datatables');
          console.log(response);
          if (response.status == 'success') {
            this.page = Number(response.page_actual);
            this.totalItems = Number(response.total_items_count);
            this.totalPaginas = Number(response.total_pages);
            for (let element of response.data) {
              this.staffData.rows.push(
                [
                  new Cell(element.id),
                  new Cell(element.name + ' ' + element.surname),
                  new Cell(element.ocupation),
                  new Cell(this.mtds.capitalize(this.pipeRep(element.role))),
                  new Cell(element.city),
                  new Cell(element.activo == 1 ? 'Active' : 'Inactive', {type: 'action-button', value: {id: element.id}, icon: 'power_settings_new', class: element.activo == 1 ? 'btn-success' : 'gts-btn-secondary ' ,typeaction: element.activo  == 1 ? 'Active' : 'Inactive'}),
                  new Cell(
                    [
                      { icon: 'remove_red_eye', action: 'Detail', color: 'info' }
                    ], {type: 'actions'}
                  )
                ]
              );
            }

            this.loading = 'hide';

          } else {
            localStorage.clear();
            this._router.navigate(['/pages/lock']);

          }
          this.cargando = false;
        },
        error => {
          console.log(<any>error);
          this.cargando = false;
        }
      );
    });
  }


  deleteUser() {
    let id = $("#borrarUser").val();
    console.log(id + "aqui");
    this._userService.deleteUser(this.token, id).subscribe(
      response => {
        if (response.status == 'success') {
          //this._router.navigate(['/']);
          // this.getAllPacientes();
          alert("Done");
        } else {
          alert("No se ha borrado el usuario");
        }
      },
      error => {
        console.log(<any>error);
      }
    );
  }

  ngAfterViewInit() {
    $('#datatables').DataTable({
      dom: 'Bflrtip',
      buttons: [
        /*{
          extend: 'copy',
          exportOptions: {
            columns: ':visible'
          }
        },*//*
        {
          extend: 'csv',
          exportOptions: {
            columns: ':visible'
          }
        },*/
        {
          extend: 'excel',
          text: '<i class="fa fa-file-excel-o"></i>',
          titleAttr: 'Excel',
          className: 'btn btn-sm btn-outline-success',
          exportOptions: {
            columns: ':visible'
          }
        },
        {
          extend: 'pdf',
          text: '<i class="fa fa-file-pdf-o"></i>',
          titleAttr: 'PDF',
          className: 'btn btn-sm btn-outline-danger',
          exportOptions: {
            columns: ':visible'
          }
        },
        {
          extend: 'print',
          text: '<i class="fa fa-print" aria-hidden="true"></i>',
          titleAttr: 'print',
          className: 'btn btn-sm btn-outline-primary',
          exportOptions: {
            columns: ':visible'
          }
        },
        {
          extend: 'colvis',
          text: '<i class="fa fa-columns" aria-hidden="true"></i>',
          className: 'btn btn-sm btn-outline-info',
          titleAttr: 'Column visibility'
        },
      ],
      "pagingType": "full_numbers",
      "lengthMenu": [
        [10, 25, 50, -1],
        [10, 25, 50, "All"]
      ],
      responsive: true,
      language: {
        search: "_INPUT_",
        searchPlaceholder: "Search Rep",
      }

    });

    const table = $('#datatables').DataTable();

    // Edit record
    table.on('click', '.edit', function () {
      const $tr = $(this).closest('tr');

      const data = table.row($tr).data();
      alert('You press on Row: ' + data[0] + ' ' + data[1] + ' ' + data[2] + '\'s row.');
    });

    // Delete a record
    table.on('click', '.remove', function (e) {
      e.preventDefault();

      var txt;
      var r = confirm("Are you sure to delete this user?");
      if (r == true) {
        const $tr = $(this).closest('tr');
        const data = table.row($tr).data();

        table.row($tr).remove().draw();
        $("#borrarUser").val(data[0]);

        $("#borrarUser").trigger("click");
      } else {

      }


    });

    //Like record
    table.on('click', '.like', function () {
      alert('You clicked on Like button');
    });

    $('.card .material-datatables label').addClass('form-group');
  }
}

@Component({
  selector: 'registro-personal',
  templateUrl: 'registro-personal.html',
  styleUrls: ['registro-personal.component.css'],
  providers: [UserService, LocationService]
})
export class NuevoPersonal {
  public mtds: Methods = new Methods();
  public identity;
  public token;
  public user: User;
  public status_user;
  public privilegio;
  public warehouseList;
/*   firstFormGroup = this._formBuilder.group({
    firstCtrl: ['', Validators.required],
  });
  secondFormGroup = this._formBuilder.group({
    secondCtrl: ['', Validators.required],
  }); */
  sexos = [
  { value: '0', viewValue: 'Female' },
    { value: '1', viewValue: 'Male' },
    { value: '2', viewValue: 'Other' }
  ];

  frequencies = [
    { value: 'DAILY', viewValue: 'Daily' },
    { value: 'WEEKLY', viewValue: 'Weekly' },
    { value: 'MONTHLY', viewValue: 'Monthly' },
    { value: 'NEVER', viewValue: 'Never' },
  ];

  public deptos = [
    { value: 'SALESREP', viewValue: 'Sales' },
    { value: 'MANIFESTDEPARTMENT', viewValue: 'Manifest' },
    { value: 'RECEIVINGDEPARTMENT', viewValue: 'Receiving' },
    { value: 'TECHREP', viewValue: 'Tech' },
  ]
  searching: boolean = false;
  public groupsList: any[] = [];

  constructor(private _formBuilder: FormBuilder,
    private _locationService: LocationService,
    public dialogRef: MatDialogRef<NuevoPersonal>,
    @Inject(MAT_DIALOG_DATA) public data: any, private _userService: UserService,
    private _route: ActivatedRoute,
    private _router: Router) {
    console.log(data);
    this.privilegio = JSON.parse(localStorage.getItem("privilegio"));
    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();
    this.getWarehouse();
    this.getUsersRoles();
  }
  isSmallScreen = window.innerWidth < 600;
  
  orientation: 'horizontal' | 'vertical' = 'horizontal';
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.updateOrientation();
  }
  private updateOrientation() {
    this.orientation = window.innerWidth < 600 ? 'vertical' : 'horizontal';
  }
  //
  formatDate(date: Date): string {
    const day = ('00' + date.getDate()).slice(-2);
    const month = ('00' + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  }
  //

  ngOnInit() {
    this.data.user.enableAsDriver = 0;
    this.data.user.bugadmin = 0 ;
    this.updateOrientation();
    if (this.identity == null && this.identity.sub) {
      this._router.navigate(['/pages/lock']);
    } else {
      console.log(this.identity);
     // this.data.user.company = this.identity.companyInfo;
    }
  }

  getUsersRoles() {

    this._userService.getUsersRoles(this.token).subscribe(
      response => {
        console.log(response);
        let group;

        if (response.code == 400) {
          localStorage.clear();
          this._router.navigate(['/pages/lock']);
        }

        for (group of response.data) {
          if (group.role != 'customer' && group.role != 'VENDOR') {
            let item: any;
            let name = group.role;
            switch (name) {
              case 'CLERICALREP':
                name = "CLERICAL REP";
                break;
              case 'PURCHASINGREP':
                name = "PURCHASING REP";
                break;
              case 'RECEIVINGDEPARTMENT':
                name = "RECEIVING DEPARTMENT";
                break;
              case 'MANIFESTDEPARTMENT':
                name = "MANIFEST DEPARTMENT";
                break;
              case 'SALESREP':
                name = "SALES REP";
                break;
              case 'SHIPPINGREP':
                name = "SHIPPING REP";
                break;
              case 'TECHREP':
                name = "TECH REP";
                break;
              case 'WAREHOUSEREP':
                name = "WAREHOUSE REP";
                break;
            }
            item = {
              id: group.role,
              name: name
            };
            this.groupsList.push(item);
          }
        }
      }
    );
  }

  getWarehouse() {

    this._locationService.getLocations(this.token).subscribe(
      response => {
        console.log(response);
        if (response.code === 400 && response.msg === 'Authorization not valid') {
          this.mtds.notifyError('Your session has expired');
          localStorage.clear();
          this._router.navigate(['/pages/lock']);
        } else if (response.status === 'success') {
          this.warehouseList = response.data;
        } else {
          //this.showSwal('error', 'ERROR!', response.msg);
        }
      },
      error => {
        console.log(<any>error);
        // this.mtds.notifyError('error');
      }
    );

  }

  onSubmit() {
    this.searching = true; 
    console.log("enviamos");
    if (this.data.user.birthDate) {
      this.data.user.birthDate = this.formatDate(new Date(this.data.user.birthDate));
    }
    if (this.data.user.joinToWork) {
      this.data.user.joinToWork = this.formatDate(new Date(this.data.user.joinToWork));
    }
    console.log(this.data.user);
    this._userService.create(this.token, this.data.user).subscribe(
      response => {
        console.log(response);
        this.status_user = response.status;

        if (this.status_user != 'success') {
          if(response.msg === "User already exist"){
            this.showToast('error', 'User already exist', 2000)
            this.searching = false;
          }else{
            this.showToast('error', response.msg, 2000)
            this.searching = false;
            this.dialogRef.close();
        }
          this.status_user = 'error';

        } else {
          this.data.user = response.data;
          //this._router.navigate(['/task', this.task.id]);
          this.dialogRef.close();
          this.showToast('success', 'New Representative has been created', 2000)
          this.searching = false;
          return this.data.user;
        }
      },
      error => {
        console.log(<any>error);
        this.searching = false;
      }
    );
  }
  cerrar(){
    this.dialogRef.close();
  }
  onCheckboxChange(event: MatCheckboxChange) {
    this.data.user.enableAsDriver = event.checked ? 1 : 0;
  }
  BugAdmin(event: MatCheckboxChange) {
    this.data.user.bugTicketNotify = event.checked ? 1 : 0;
  }
  onNoClick(): void {
    console.log(this.data)
  }
  showToast(type, title, timer) {
    const Toast = swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: timer,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = swal.stopTimer;
        toast.onmouseleave = swal.resumeTimer;
      }
    })
    Toast.fire({
      icon: type,
      title: title
    });
  }

}
